const WASTE_BASE_PATH = "/waste";
export const RoutesList = {
  WASTE_HOME: WASTE_BASE_PATH,
  TEST_LANDING_PAGE: "/",
  UPLOAD_PHOTO: WASTE_BASE_PATH + "/upload-photo",
  WASTE_DETAILS: WASTE_BASE_PATH + "/waste-details",
  YOUR_DETAILS: WASTE_BASE_PATH + "/your-details",
  CONFIRMATION: WASTE_BASE_PATH + "/confirmation",
  WASTE_LOGIN_PAGE: WASTE_BASE_PATH + "/login",
  NOT_FOUND: "*",
  INTERNAL_SERVER_ERROR: "/500"
};
